import { Injectable } from '@angular/core';
// import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ModuleauthService {
  setRestriction: any
  view: any
  constructor() { }



  isAuthenticatedmodule() {
    if(localStorage.getItem('selectedModule')) {
      const selectedModule = JSON.parse(localStorage.getItem('selectedModule'))
      console.log(selectedModule)
      return true
    }
    return false;
  }

  getModule() {
    this.setRestriction  = JSON.parse(localStorage.getItem('selectedModule'));
    return this.setRestriction;
  }
}
